import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class AppService {

  public access_tocken = "";
 public Server_URL = "https://sbltvisitorapi.genuineitsolution.com/";
  //  public Server_URL = "http://localhost:14376/";
  public data: any = {};
  isload: boolean = false;
  public Company = "";
  public Company_ = "_1";
  public Company_Name = "Chennai";
  public CREATED_BY = "";
  public Ref_ID = "0";
  public isadd = "0";
  public URL_Location = "";
  public Edit_Row: any = {};
  public Edit_Row1: any = {};
  public Default_ref_ID: string = "User_Role";
  public Logo_location = "Letter";
  public T_Date = "";
  public T_Date_Time = "";

  public W_height = 0;
  public W_width = 0;
  public S_From = " ";
  public S_To = " ";

  public Feed_Back_Link = "Thank you for your visit to Shri Bhagiyalakshimi Travels. Click the link to share your visit feedback."


  public Cam_Type = "Proof";
  public Proof_Image: any;
  public Selfie_Image: any;
  public Empty_Image: any;

  constructor(public http: HttpClient,
    public router: Router,
    public datePipe: DatePipe,
    private _location: Location, private toastr: ToastrService) {
    if (this.getData()) {

      this.data = JSON.parse(localStorage.getItem('User_Data'));
      this.Company = "_" + this.data.UM_Company;
      this.CREATED_BY = this.data.UM_Full_Name;
    }

    this.T_Date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.T_Date_Time = this.datePipe.transform(new Date(), "yyyy-MM-ddTHH:mm");
    this.S_From = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.S_To = this.datePipe.transform(new Date(), "yyyy-MM-dd");

  }

  public Side_Menu: boolean = false;
  public Rights_Name = "";
  public Rights_ID = "";
  public Emp_ID = "";
  public U_Rights = ""
  public Status = "A";

  get_dt(date) {
    return this.datePipe.transform(date, "yyyy-MM-dd");
  }

  public datefromat(data) {
    return this.datePipe.transform(data, "yyyy-MM-dd");
  }

  public datetimefromat(data) {
    const [day, month, yearTime] = data.split("-");
    const [year, time] = yearTime.split(" ");
    const formattedDateStr = `${year}-${month}-${day} ${time}`;
    const dateObj = new Date(formattedDateStr);

    return this.datePipe.transform(dateObj, "yyyy-MM-ddTHH:mm");
  }
  getData() {
    return JSON.parse(localStorage.getItem('User_Data'));
  }

  headers;

  public tocken = "";
  get_Token() {
    this.headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.isload = true;
    this.http.post(this.Server_URL + 'token', 'grant_type=password&UserName=admin&Password=admin', { headers: this.headers })
      .subscribe(
        (val) => {
          this.tocken = val['access_token'];

        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });
  }
  get(url) {
    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': 'Bearer ' + this.access_tocken
    });
    return this.http.get(this.Server_URL + "" + url + "&Company=" + this.Company, { headers: reqHeader })
  }

  getc(url) {
    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Authorization': 'Bearer ' + this.access_tocken
    });
    return this.http.get(this.Server_URL + "" + url + "?Company=" + this.Company, { headers: reqHeader });
  }

  public back() {
    this._location.back();
  }

  public isEdit: boolean = false;


  // Set an item
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  // Get an item
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  // Remove an item
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all items
  clear(): void {
    localStorage.clear();
  }


  public Details_Row = [];

  Reference_Rows = [];
  get_Reference() {

    this.getc("Api/Master/get_reference").subscribe((res: any) => {
      this.Reference_Rows = JSON.parse(res).record;
    });
  }

  get_ref(data: any) {
    try {
      return this.Reference_Rows.filter(e => e.Ref_ID == data);
    } catch {

      return [];
    }
  }

  public Field_Setting: any[] = [];
  F_Row = [];
  get_fields_of(Table) {

    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table).toLowerCase()).filter(e => e.Visible == "True");
    return this.F_Row.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));

  }

  get_grid_fields_of(Table) {

    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table).toLowerCase()).filter(e => e.GVisible == "True");
    return this.F_Row.sort((a, b) => Number(a["GOrder"]) - Number((b["GOrder"])));

  }



  public Selected_Customer: any = {};
  public Employee_Details_Rows = [];
  get_Employee_Details() {

    this.getc("Api/Master/get_Employee_Details").subscribe((res: any) => {
      this.Employee_Details_Rows = JSON.parse(res).record;
    });

  }

Welcome_Message: string = "";
  public Area_Details_Rows = [];
  get_Area_Details() {
    this.Area_Details_Rows = [];
    this.get("Api/visitor/get_Area_Details?ID=" + this.Company.replace("_", "")).subscribe((res: any) => {
      this.Area_Details_Rows = JSON.parse(res).record;

      this.Company_Name = this.Area_Details_Rows[0].Araa;
       this.Welcome_Message = this.Area_Details_Rows[0].Welcome_Message || "Welcome!";


    });

  }


// public Area_Details_Rows = [];
// get_Area_Details() {
//   this.Area_Details_Rows = [];

//   if (!this.Company) {
//     console.error("Company is empty");
//     return;
//   }

//   const id = this.Company.replace("_", "");

//   console.log("Sending ID:", id);

//   this.get("Api/visitor/get_Area_Details?ID=" + id)
//     .subscribe((res: any) => {
//       const parsed = JSON.parse(res);
//       this.Area_Details_Rows = parsed.record;

//       if (this.Area_Details_Rows.length > 0) {
//         this.Company_Name = this.Area_Details_Rows[0].Araa;
//       }
//     });
// }


  changeUrlFragment(newFragment: string) {
    this._location.go(this._location.path().split('#')[0] + '#' + newFragment);
  }

  // changeUrlFragment(newFragment: string) {
  //   this.router.navigate([], {
  //     fragment: newFragment
  //   });

}
